import { render, staticRenderFns } from "./ServiceASPage.vue?vue&type=template&id=5d01fd2e&scoped=true&"
import script from "./ServiceASPage.vue?vue&type=script&lang=js&"
export * from "./ServiceASPage.vue?vue&type=script&lang=js&"
import style0 from "./ServiceASPage.vue?vue&type=style&index=0&id=5d01fd2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d01fd2e",
  null
  
)

export default component.exports